import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const navGroups = [
    {
      title: t('footer.browse'),
      links: [
        [t('nav.clubs'),'/clubs'], [t('nav.events'),'/events'], [t('nav.larp'),'/larp'],
        [t('nav.news'),'/news'], [t('nav.locations'),'/locations'], [t('footer.publishers'),'/publishers'],
      ],
    },
    {
      title: t('footer.info'),
      links: [
        [t('footer.about'),'/about'], [t('footer.contact'),'/contact'],
        [t('footer.privacy'),'/privacy'], [t('footer.terms'),'/terms'],
        ['💡 ' + t('footer.wishlist'),'/wishlist'],
      ],
    },
    {
      title: t('footer.advertise'),
      links: [
        ['info@fantastai.lt','mailto:info@fantastai.lt'],
        [t('pages.pricing.title'),'/pricing'],
        [t('pages.media.title'),'/media-kit'],
      ],
    },
  ];
  const socials = [
    { label: 'Facebook', icon: '📘' },
    { label: 'Instagram', icon: '📸' },
    { label: 'TikTok', icon: '🎵' },
    { label: 'YouTube', icon: '▶️' },
    { label: 'Discord', icon: '💬' },
  ];

  return (
    <footer className="footer-wh">
      <div className="footer-ornament" />

      <div className="footer-main">
        <div>
          <div className="footer-brand-row">
            <div className="footer-logo-icon">⚔️</div>
            <div className="footer-logo-text">FANTASTAI.LT</div>
          </div>
          <p className="footer-desc">
            {t('footer.desc')}
          </p>
          <div className="footer-socials">
            {socials.map(({ label, icon }) => (
              <button key={label} title={label} className="footer-social-btn"
                onMouseEnter={e => { e.currentTarget.style.background='rgba(240,192,64,0.1)'; e.currentTarget.style.borderColor='rgba(240,192,64,0.4)'; }}
                onMouseLeave={e => { e.currentTarget.style.background='rgba(255,255,255,0.04)'; e.currentTarget.style.borderColor='rgba(240,192,64,0.15)'; }}
              >{icon}</button>
            ))}
          </div>
        </div>

        <div className="footer-links-grid">
          {navGroups.map(({ title, links }) => (
            <div key={title}>
              <div className="footer-link-group-title">{title}</div>
              {links.map(([label, href]) => (
                href.startsWith('mailto:') || href.startsWith('http') ? (
                  <a key={label} href={href} className="footer-link-item"
                    onMouseEnter={e => e.currentTarget.style.color='rgba(240,192,64,0.9)'}
                    onMouseLeave={e => e.currentTarget.style.color='rgba(255,255,255,0.55)'}
                  >{label}</a>
                ) : (
                  <button key={label} onClick={() => navigate(href)} className="footer-link-item"
                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, textAlign: 'left' }}
                    onMouseEnter={e => e.currentTarget.style.color='rgba(240,192,64,0.9)'}
                    onMouseLeave={e => e.currentTarget.style.color='rgba(255,255,255,0.55)'}
                  >{label}</button>
                )
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <span style={{ color: '#fff', fontSize: 12, fontFamily: 'Cinzel,Georgia,serif', letterSpacing: 1.5 }}>
            © 2025 FANTASTAI.LT — {t('footer.rights').toUpperCase()}
          </span>
          <span style={{ color: '#fff', fontSize: 12, fontFamily: 'Cinzel,Georgia,serif', letterSpacing: 1.5, opacity: 0.85 }}>
            {t('footer.made_for').toUpperCase()} ⚔️
          </span>
        </div>
      </div>
    </footer>
  );
}
